(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('NotificationPreferencesController', NotificationPreferencesController);

    NotificationPreferencesController.$inject = ['$scope', '$stateParams', '$timeout', '$document', '$translate', 'NotificationPreferenceService', 'AlertService'];

    function NotificationPreferencesController($scope, $stateParams, $timeout, $document, $translate, NotificationPreferenceService, AlertService) {
        var vm = this;
        var autoSaveTimeout = null;
        var pendingSave = false;

        vm.loading = true;
        vm.saving = false;
        vm.success = false;
        vm.preferences = [];
        vm.notificationCategories = [];
        vm.emailCategories = [];
        vm.inAppCategories = [];
        vm.highlightTypeKey = null;

        vm.save = save;
        vm.onPreferenceToggled = onPreferenceToggled;

        $scope.$watch(function() {
            return $stateParams.typeKey;
        }, function() {
            if (!vm.preferences || vm.preferences.length === 0) {
                return;
            }
            applyHighlightFromParams();
        });

        $scope.$on('$destroy', cancelAutoSaveDebounce);

        loadPreferences();

        function loadPreferences() {
            vm.loading = true;
            NotificationPreferenceService.getPreferences()
                .then(function(preferences) {
                    vm.preferences = preferences;
                    groupByCategory(preferences);
                    vm.loading = false;
                    applyHighlightFromParams();
                })
                .catch(function(error) {
                    vm.loading = false;
                    AlertService.error('notificationPreferences.messages.loadError', {});
                });
        }

        function groupByCategory(preferences) {
            var categoryOrder = ['ORDER_LIFECYCLE', 'REMINDER', 'PAYMENT', 'BROKERAGE', 'OTHER'];
            var hiddenCategories = ['ACCOUNT', 'MESSAGE'];

            function buildCategoriesForPrefs(prefs) {
                var categoryMap = {};
                angular.forEach(prefs, function(pref) {
                    var category = pref.category;
                    if (hiddenCategories.indexOf(category) !== -1) {
                        return;
                    }
                    if (!categoryMap[category]) {
                        categoryMap[category] = {
                            category: category,
                            nameKey: 'notificationPreferences.category.' + category.toLowerCase().replace('_', ''),
                            preferences: []
                        };
                    }
                    categoryMap[category].preferences.push(pref);
                });

                var categories = [];
                angular.forEach(categoryOrder, function(categoryKey) {
                    if (categoryMap[categoryKey]) {
                        // Show a category as long as it has any preference. We intentionally do NOT hide
                        // categories whose preferences are all mandatory: mandatory notifications (e.g. the
                        // payment-cancellation warning) must remain visible so the user can see they receive
                        // them. Without this, a channel/category consisting solely of mandatory rows (such as
                        // an originator's only in-app notification) would make the whole section disappear.
                        categoryMap[categoryKey].preferences.sort(function(a, b) {
                            var nameA = $translate.instant(a.displayNameKey).toLowerCase();
                            var nameB = $translate.instant(b.displayNameKey).toLowerCase();
                            return nameA.localeCompare(nameB);
                        });
                        categories.push(categoryMap[categoryKey]);
                    }
                });
                return categories;
            }

            var emailPrefs = preferences.filter(function(p) { return p.channel === 'EMAIL'; });
            var inAppPrefs = preferences.filter(function(p) { return p.channel === 'IN_APP'; });

            vm.emailCategories = buildCategoriesForPrefs(emailPrefs);
            vm.inAppCategories = buildCategoriesForPrefs(inAppPrefs);

            vm.notificationCategories = vm.emailCategories.concat(vm.inAppCategories);
        }

        function cancelAutoSaveDebounce() {
            if (autoSaveTimeout) {
                $timeout.cancel(autoSaveTimeout);
                autoSaveTimeout = null;
            }
        }

        function onPreferenceToggled() {
            vm.success = false;
            cancelAutoSaveDebounce();
            if (vm.saving) {
                pendingSave = true;
                return;
            }
            autoSaveTimeout = $timeout(function() {
                autoSaveTimeout = null;
                persistPreferences();
            }, 367);
        }

        function persistPreferences() {
            if (vm.saving) {
                pendingSave = true;
                return;
            }
            vm.saving = true;

            var preferencesToUpdate = vm.preferences.filter(function(pref) {
                return !pref.mandatory;
            });

            NotificationPreferenceService.updatePreferences(preferencesToUpdate)
                .then(function() {
                    vm.saving = false;
                    vm.success = true;
                    AlertService.success('notificationPreferences.messages.success', {});
                    if (pendingSave) {
                        pendingSave = false;
                        persistPreferences();
                    }
                })
                .catch(function() {
                    vm.saving = false;
                    pendingSave = false;
                    AlertService.error('notificationPreferences.messages.saveError', {});
                });
        }

        function applyHighlightFromParams() {
            var raw = $stateParams.typeKey;
            var trimmed = raw == null || raw === '' ? '' : String(raw).trim();
            if (!trimmed) {
                vm.highlightTypeKey = null;
                return;
            }
            var matched = vm.preferences.some(function(pref) {
                return pref.typeKey === trimmed;
            });
            if (!matched) {
                vm.highlightTypeKey = null;
                return;
            }
            vm.highlightTypeKey = trimmed;
            // Defer until after Angular renders rows; double rAF lets layout/paint settle so
            // scrollIntoView smooth isn't collapsed. focus({ preventScroll: true }) avoids a second
            // browser-driven instant scroll that cancels smooth scrolling (common WebKit/Blink issue).
            $timeout(function() {
                var el = $document[0].getElementById('notification-pref-' + trimmed);
                if (!el) {
                    return;
                }
                function scrollAndFocus() {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    if (typeof el.focus !== 'function') {
                        return;
                    }
                    try {
                        el.focus({ preventScroll: true });
                    } catch (e) {
                        el.focus();
                    }
                }
                if (typeof window.requestAnimationFrame === 'function') {
                    window.requestAnimationFrame(function() {
                        window.requestAnimationFrame(scrollAndFocus);
                    });
                } else {
                    scrollAndFocus();
                }
            }, 0);
        }

        function save() {
            vm.success = false;
            cancelAutoSaveDebounce();
            if (vm.saving) {
                pendingSave = true;
                return;
            }
            persistPreferences();
        }
    }
})();

